import { render } from "./Home copy.vue?vue&type=template&id=59704a8c"
import script from "./Home copy.vue?vue&type=script&lang=js"
export * from "./Home copy.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__